var e=function(_){return _.HOTEL_VISITS="hotels_visits",_.HOUSE_VISITS="house_visits",_.SWINGER_CLUBS="swinger_clubs",_}({});export{e as VisitStatus};